import img from '@assets/Imgs/defaultItemImg.png';
export const DEFAULT_ITEM_IMAGE: string = img;
